import { render, staticRenderFns } from "./video_page.vue?vue&type=template&id=f9c4863c&scoped=true"
import script from "./video_page.vue?vue&type=script&lang=js"
export * from "./video_page.vue?vue&type=script&lang=js"
import style0 from "./video_page.vue?vue&type=style&index=0&id=f9c4863c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c4863c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9c4863c')) {
      api.createRecord('f9c4863c', component.options)
    } else {
      api.reload('f9c4863c', component.options)
    }
    module.hot.accept("./video_page.vue?vue&type=template&id=f9c4863c&scoped=true", function () {
      api.rerender('f9c4863c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/video/video_page.vue"
export default component.exports